import React from "react";
import SectionContainer from "../../components/SectionContainer";
import SectionHead from "../../components/SectionHead";
import TeamBlock from "./TeamBlock";
import Services from "../../components/Services";

const Team = () => {
  return (
    <SectionContainer id={"team"} secName={"team-sec"}>
      <SectionHead
        head={"team"}
        text={
          "Our talented and dedicated team  is committed to delivering innovative software solutions that exceed our clients' expectations."
        }
      />
       <Services />
      <TeamBlock />
    </SectionContainer>
  );
};

export default Team;
